import React, { useState } from "react";
import Icon, { IconType } from "../Icon/Icon";
import NewSite from "./Content/NewSite";
import RefreshSite from "./Content/RefreshSite";
import { IState, ReduxMap } from "../../redux/redux";
import CockpitSetupLink from "./Content/CockpitSetupLink";

const SetupStart = (props: IState) => {
  const [setupType, setSetupType] = useState<"new" | "refresh" | "unknown">(
    "unknown"
  );
  const cockpitOn = !!props.Settings?.EnableEventCockpit;
  const fairId = props.Settings?.fairId;

  const GetWizardTitle = ()=>{
      switch(setupType){
        case 'new':
        return 'New Contest Setup Guide';
        break;
        case 'refresh':
        return 'Contest Refresh Guide';
        break;
      }
  };

  const SetupContent = () =>{
    switch(setupType){
        case 'new':
        return <NewSite cockpitOn={cockpitOn} fairId={fairId} />;
        break;
        case 'refresh':
        return <RefreshSite cockpitOn={cockpitOn} fairId={fairId} />;
        break;
      }
  };

  return (
    <div className="col-sm-12" data-testid="setup-start-page">
      {setupType === "unknown" && (
        <div>
          <div className="start-heading">
            <h3>Let's Get Started...</h3>
          </div>
          <div>
            Let's get started, select an option below to start and we can get
            you pointed in the right direction.
          </div>
          {cockpitOn && (
            <CockpitSetupLink
              fairId={fairId}
              lead="Event Cockpit is the primary next step for first-time setup and a new season. First Time Setup and Refresh Site still keep their checklists until intake covers those steps."
            />
          )}
          <div className="alert alert-info">
            <h4>
              <Icon type={IconType.warning} /> New Feature Warning!
            </h4>
            <p>
            We are supper excited about this new feature but it is just now
            being developed, so this is just the most basic concept of what we
            are creating. Feel free to let us know how we can make it better.
                Our goal is to make is so that a user could setup or refresh their site so it is ready for registration and judging in 5 minutes.
            </p>
          </div>
          <hr />
          <div className="wiz-setup-types-container flex-centered">
            <div className="wiz-setup-type-tile">
              <div>
                <h3>First Time Setup</h3>
                <hr />
              </div>
              <div className={`flex-grow ${cockpitOn ? "" : "alert alert-danger"}`}>
                  {cockpitOn
                    ? "Open Event Cockpit to apply the template and set dates. A full new-site wizard is still coming."
                    : "Coming soon."}
              </div>
              <div>
                <hr />
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-testid="setup-start-new"
                  onClick={() => {
                    setSetupType("new");
                  }}
                  disabled={!cockpitOn}
                >
                  Start
                </button>
              </div>
            </div>
            <div className="wiz-setup-type-tile">
              <div>
                <h3>Refresh Site</h3>
                <hr />
              </div>
              <div className="flex-grow">
                Select this to refresh your site for your next contest.
              </div>
              <div>
                <hr />
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-testid="setup-start-refresh"
                  onClick={() => {
                    setSetupType("refresh");
                  }}
                >
                  Start
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {setupType !== "unknown" && (
        <div>
          <div className="flex-between">
            <h3>{GetWizardTitle()}</h3>
            <div>
                <button type="button" className="btn btn-default"
                onClick={()=>{setSetupType('unknown')}}>
                    <Icon type={IconType.close}/> Exit
                </button>
            </div>
          </div>
          <hr/>
          <div>
            {SetupContent()}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReduxMap(SetupStart);
